import { RootState } from 'app/store';

export const selectIsLoadingSummary = (state: RootState) =>
  state.summary.isLoadingSummary;
export const selectKpis = (state: RootState) => state.summary.kpis;
export const selectQuarter = (state: RootState) => state.summary.quarter;
export const selectQuarterTotal = (state: RootState) =>
  state.summary.quarterTotal;
export const selectYear = (state: RootState) => state.summary.year;
